module.exports = __webpack_public_path__ + "static/images/callout_1.2f403e6b114959e070596c53d84b889f.jpg";